import type { MarketInfo } from "./types";
import { getMarketPoolName } from "./utils";

export function getPreferredMarketDisplayName(marketInfo?: Pick<MarketInfo, "longToken" | "shortToken">) {
  if (!marketInfo) {
    return undefined;
  }

  return getMarketPoolName(marketInfo, "-");
}
